import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { usePhonesChartsDataContext } from './hooks/usePhonesChartsDataContext';
import { useSanitizeData } from '../../Common/hooks/useSanitizeData';

export const TypeAnualList = () => {
    const { chartData } = usePhonesChartsDataContext();

    const tableColumns = [
            {
                key: 'ano_registro_bo',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'desc_tipo_objeto',
                header: 'Tipo do Aparelho',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.typeAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.tipos.map((desc_tipo_objeto) => ({
            ...desc_tipo_objeto,
            ano_registro_bo: itemAno.ano_registro_bo
        }));
    });

    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Tipo do Aparelho - Anual"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};